import {getLoginUser, getAccessToken} from "@/service/authentication/authentication";
import localStorage from '@/service/storage/localStorageService'
import {LOGIN_USER_INFO, CAPTCHA_TOKEN} from "@/service/keys";

export default {

  install(Vue, options) {

    Vue.prototype.$loginUser = getLoginUser()

    Vue.prototype.$accessToken = () =>{
      const loginUser = localStorage.getObj(LOGIN_USER_INFO)
      // console.log('loginUser', loginUser)
      if (!loginUser) {
        return ''
      }
      // console.log('loginUser.accessToken', loginUser.accessToken)
      return loginUser.accessToken
    }

  }
}